import styled, { css } from 'styled-components'
import { Link } from '../../components/Link'
import { STYLES } from '../../static/style'
import { TopNavColor } from './TopNav.types'

export const TopNavLinkStyle = css`
  ${({ color }: { color: TopNavColor }) =>
    ({
      [TopNavColor.NORMAL]: `
        color: ${STYLES.COLOR_WHITE};
        &:hover {
          text-decoration: none;
        }
      `,
      [TopNavColor.GRAY]: `
        color: ${STYLES.COLOR_OUTER_SPACE_GRAY};
        &:hover {
          color: ${STYLES.COLOR_OUTER_SPACE_GRAY};
          text-decoration: underline;
        }
      `,
    }[color])}
  padding: 0 1.4rem;
  display: flex;
  height: 100%;
  align-items: center;
`

export const TopNavLink = styled(Link)`
  ${TopNavLinkStyle}
`
